module.exports = __webpack_public_path__ + "static/media/r20.bcfc7018.jpg";